export default __webpack_public_path__ + "static/media/riya.3f30bf2d.jpg";